export const searchResults = "Fab";
export const searchResultsFromArchive = "Gab";
export default {searchResults,searchResultsFromArchive};